import { IntlShape } from 'react-intl';
import { object as YupObject, ObjectShape, string as YupString } from 'yup';

import { SurveyQuestion } from 'app/shared/typings/surveyQuestions';

const organizerSurveyFormSchema = (
  intl: IntlShape,
  surveyQuestions: SurveyQuestion[]
) => {
  const requiredMessage = intl.formatMessage({ id: 'form.requiredField' });

  return YupObject().shape({
    surveyAnswers: YupObject().shape(
      surveyQuestions.reduce(
        (obj: ObjectShape, surveyQuestion: SurveyQuestion) => {
          const { isRequired, questionType } = surveyQuestion;

          let answerText = YupString().nullable();
          let optionId = YupString().nullable();

          if (isRequired) {
            if (questionType === 'free_text') {
              answerText = answerText.required(requiredMessage);
            } else if (questionType === 'single_option_select') {
              optionId = optionId.required(requiredMessage);
            }
          }

          return {
            ...obj,
            [surveyQuestion.id?.toString() || '']: YupObject().shape({
              answerText,
              optionId,
            }),
          };
        },
        {}
      ) || {}
    ),
  });
};

export default organizerSurveyFormSchema;
